import {createReducers} from 'redux-arc';
import {sortBy} from 'lodash';
import {types} from '../actions/jobs';
import * as utils from './utils';

export const INITIAL_STATE = {
  currentJob: null,
  listResult: [],
  listIsLoading: false,
  listError: null,
  readResult: null,
  readIsLoading: false,
  readError: null
};

const onSetCurrentJob = (state, action) => ({
  ...state,
  currentJob: action.payload
});

const onResetCurrentJob = state => {
  return {
    ...state,
    currentJob: null
  };
};

const onJobListResponse = (state, action) => {
  if (action.error) {
    return {
      ...state,
      listIsLoading: false,
      listError:
        (action.payload.response && action.payload.response.data) || true,
      listResult: []
    };
  }

  return {
    ...state,
    listIsLoading: false,
    listResult: sortBy(action.payload.data, ['name'])
  };
};

const HANDLERS = {
  [types.READ.REQUEST]: utils.onReadRequest,
  [types.READ.RESPONSE]: utils.onReadResponse,
  [types.LIST.REQUEST]: utils.onListRequest,
  [types.LIST.RESPONSE]: onJobListResponse,
  [types.SET_CURRENT_JOB]: onSetCurrentJob,
  [types.RESET_CURRENT_JOB]: onResetCurrentJob
};

export const jobs = createReducers(INITIAL_STATE, HANDLERS);
